import React from 'react'
import { Link } from 'react-router-dom';

const ProjectComponentRight = (props) => {

  let challanges_object = Object.entries(props.data.project_challanges);
  let tech_stack_object = Object.entries(props.data.tech_stack);

  return (
    <>
      {/* <div style={{ height: "480px", overflow: "scroll", width: "100%", backgroundColor: "#313139", color: "#fff" }} className='card p-2'> */}
      <div class="custom-scroll-container" style={{ height: "480px", overflow: "scroll", overflowX: "hidden", width: "100%", backgroundColor: "#313139", color: "#fff" }} className='card p-2'>
        <div className="custom-scroll-content">

          <h6 style={{ color: "#d29345", fontWeight: "bold" }} className="card-title">Project Goal</h6>
          <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />

          <span style={{ fontSize: "14px", textAlign: "justify" }}>
            {props.data.project_goal}
          </span>

          <h6 style={{ color: "#d29345", fontWeight: "bold" }} className="card-title mt-4">Project Challanges</h6>
          <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />

          <div style={{ fontSize: "14px", backgroundColor: "#212529", textAlign: "justify", padding: "16px 8px 5px 8px" }}>
            <ul>
              {challanges_object.map(([key, value]) => (
                <li key={key} className='mb-2'>
                  <strong>{key}:</strong> {value}
                </li>
              ))}
            </ul>
          </div>

          <h6 style={{ color: "#d29345", fontWeight: "bold" }} className="card-title mt-4">Tech Stack Involved</h6>
          <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />

          <div style={{ fontSize: "14px", backgroundColor: "#212529", textAlign: "justify", padding: "16px 8px 5px 8px" }}>
            <ul>
              {tech_stack_object.map(([each_key, each_value]) => (
                <li key={each_key} className='mb-2'>
                  <strong>{each_key}:</strong> {each_value}
                </li>
              ))}
            </ul>
          </div>

          {props.data.demo.available
            ?
            <>
              <h6 style={{ color: "#d29345", fontWeight: "bold" }} className="card-title mt-4">Project Demo Links</h6>
              <hr style={{ position: "relative", top: "-5px", marginBottom: "6px" }} />
              <div style={{ fontSize: "14px", backgroundColor: "#212529", textAlign: "justify", padding: "16px 8px 5px 23px" }}>

                <li className='mb-2'>
                  <strong>My Version:</strong> <Link target='_blank' to={props.data.demo.my_version_link}>My netlify version</Link>
                </li>

                <li className='mb-2'>
                  <strong>Live Version:</strong> <Link target='_blank' to={props.data.demo.live_app_link}>Company live amplify version</Link>
                </li>

              </div>
            </>
            : null}
        </div>
      </div>
    </>
  )
}

export default ProjectComponentRight